import { GameVars } from "../GameVars";
import { AdvicesManager } from "./AdvicesManager";

    export class AdvicesContainer extends Phaser.Group {

        constructor( game: Phaser.Game ) {

            super( game, null, "advices-container", false);

            this.y = 940;
            this.scale.y = GameVars.scaleY;

            const blackGradientStripe = new Phaser.Sprite(this.game, 0, 0, this.game.cache.getBitmapData("dark_gradient"));
            blackGradientStripe.scale.set(58 , 1.1);
            blackGradientStripe.alpha = .8;
            this.add( blackGradientStripe );

            const tipsHandImage = new Phaser.Image(this.game, 10, -25, "texture_atlas_1", "tips-hand");
            this.add(tipsHandImage);

            this.game.add.tween(tipsHandImage)
                .to({x: 0}, 750, Phaser.Easing.Linear.None, true, 0, -1, false);

            let adviceString = AdvicesManager.getInstance().getMessage();

            const adviceLabel = new Phaser.Text(this.game, 130, 12,
                adviceString , { font: "19px Arial", fill: "#ffffff", align: "left", wordWrap: true, wordWrapWidth: 630} );
            this.add(adviceLabel);
        }
    }
